import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum FilingStatus {
  Open = 'open',
  Closed = 'closed',
}

export interface UCCFiling {
  status?: FilingStatus;
  'filing-date'?: string;
  'expiration-date'?: string;
  'verified-date'?: string;
  'document-type'?: string;
  'filing-reference'?: string;
  'original-filing-date'?: string;
  'original-filing-reference'?: string;
  'filing-office'?: RolePlayer;
  'secured-parties'?: RolePlayer[];
  debtors?: RolePlayer[];
  collaterals?: Collateral[];
}

interface Collateral {
  'collateral-class'?: string;
  'collateral-type'?: string;
  'collateral-supplemental-items'?: string[];
  'collateral-scope-type'?: string;
}

interface RolePlayer {
  name?: string;
  duns?: string;
  'street-address-1'?: string;
  'street-address-2'?: string;
  'postal-code'?: string;
  'address-region'?: string;
  'address-city'?: string;
  'address-country'?: string;
}

export interface ReportBusinessLiensLookupAttributes extends ReportAttributes {
  query: {
    'address-country-code': string;
  };
  result: {
    'ucc-filings': UCCFiling[];
  };
  metadata: {
    'database-business-token': string;
  };
  'business-name'?: string;
}

export type ReportBusinessLiensLookup = ApiResource<
  ReportBusinessLiensLookupAttributes,
  ReportRelationships,
  ApiModel.ReportBusinessLiensLookup
>;
